export const DELIVERYBOY_LIST_CACHE = 'CACHE.KEY.DELIVERYBOY.LIST'
export const DELIVERYBOY_LIST_PARENT_CACHE = 'CACHE.KEY.DELIVERYBOY.LIST_PARENT'
export const DELIVERYBOY_LIST_BY_PARENT_CACHE = 'CACHE.KEY.DELIVERYBOY.LIST_BY_PARENT.' // +parentId
